<template>
  <div
    id="logs-tab-container"
    element-loading-background="#F7F8FC"
    v-loading="loading"
  >
    <div v-if="!loading && activityLogs.length === 0">
      Not enough data has been gathered yet to display any results
    </div>
    <div v-else>
      <el-card
        v-for="log in activityLogs"
        :key="log.id"
        style="margin-bottom: 10px"
      >
        <div slot="header">
          <strong>{{ log.user }}</strong> - {{ formatDate(log.date_created) }}
        </div>
        <div>{{ log.action }}</div>
      </el-card>
      <div v-if="loading && activityLogs.length > 0">&nbsp;</div>
      <div class="buttons-container">
        <el-button v-if="!loading && hasNext" @click="loadMore" type="primary" size="small" class="load-button" plain>Load More</el-button>
        <el-button v-if="!loading && hasPrevious" @click="loadPrevious" type="primary" size="small" class="load-button" plain>Load Previous</el-button>
      </div>
      <div v-if="!loading && activityLogs.length > 0 && !hasNext && !hasPrevious">
        <p style="text-align: center; margin-bottom: 20px;">End of logs</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivityLogsTab',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    initialProfile: {
      type: Object,
      required: true,
    },
    activityLogs: {
      type: Array,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    hasNext: {
      type: Boolean,
      required: true,
    },
    hasPrevious: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString();
    },
    loadMore() {
      this.$emit('loadMore');
    },
    loadPrevious() {
      this.$emit('loadPrevious');
    },
  },
};
</script>

<style scoped>
#logs-tab-container {
  overflow-y: scroll;
  height: 430px;
  padding: 0 8px;
  padding-bottom: 60px;
}

.buttons-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.load-button {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// ActivityLogsTab.vue?f0da37c8